import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { JdcManagerService } from '../jdc-manager.service';
import { GtwSnackbarService } from '../../../../shared/_services/gtw-snackbar.service';

@Component({
    selector: 'gtw-jdc-activity-user-list-modal',
    templateUrl: './jdc-activity-user-list-modal.component.html',
    styleUrls: ['./jdc-activity-user-list-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class JdcActivityUserListModalComponent implements OnInit, OnDestroy {
  @Input() activityKey: any;
  @Input() jcdKey: any;
  @Input() clientKey: any;
  @Input() globalParams: any;

  @Output() closed = new EventEmitter<void>();

  usersLoading = false;
  userSearchText = '';
  userList: any[] = [];

  private destroy$ = new Subject<void>();

  constructor(
    private jdcManagerService: JdcManagerService,
    private gtwSnackbarService: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.loadUsers();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadUsers(): void {
    this.userSearchText = '';
    this.userList = [];
    this.usersLoading = true;
    this.jdcManagerService.getActivityUsers(
      this.activityKey, this.jcdKey,
      this.clientKey, this.globalParams?.tax_year, this.globalParams?.scenario
    ).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.userList = res?.jsonObject || [];
        this.usersLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.usersLoading = false;
        this.gtwSnackbarService.openSnackBar('Problem loading activity users.', 'gtw-snackbar--red');
        this.cdr.detectChanges();
      }
    });
  }

  close(): void {
    this.closed.emit();
  }

  filteredUserList(): any[] {
    const search = (this.userSearchText || '').toLowerCase().trim();
    if (!search) return this.userList;
    return this.userList.filter((item: any) =>
      `${item?.USER_NAME || ''} ${item?.USER_ROLE || ''} ${item?.ASSIGNED_THROUGH || ''}`.toLowerCase().includes(search)
    );
  }
}
